import { useColorMode } from "./useColorMode";

export const useColorModeValue = <T>(lightModeValue: T, darkModeValue: T) => {
  const { colorMode } = useColorMode();
  if (colorMode === "light") {
    return lightModeValue;
  }
  return darkModeValue;
};
